import React, { lazy, Suspense } from "react";

import { isPosthogBrowserAnalyticsEnabled } from "./posthogBrowserEnabled";
import { getPostHogPublicConfig, warnIfPostHogEnvMissing } from "./posthogClientConfig";

interface ConfigurePostHogProps {
  children: React.ReactNode;
}

const LazyPostHogProviderShell = lazy(() => import("./PostHogProviderShell"));

warnIfPostHogEnvMissing(isPosthogBrowserAnalyticsEnabled);

const ConfigurePostHog = ({ children }: ConfigurePostHogProps) => {
  if (!isPosthogBrowserAnalyticsEnabled || !getPostHogPublicConfig()) {
    return children;
  }

  return (
    <Suspense fallback={children}>
      <LazyPostHogProviderShell>{children}</LazyPostHogProviderShell>
    </Suspense>
  );
};

export default ConfigurePostHog;
